let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jYxgH")).then(() => parcelRequire('dRjRH'));